import React from 'react';
import CompsWidgetRenderer from './CompsWidgetRenderer';

const Preview: React.FC = () => (
  <CompsWidgetRenderer config={{}} />
);

export default Preview;
